import { useAppContext } from 'src/components/app-context';
import React from 'react';

import { Clickable } from 'src/components/clickable';
import { BodySmallText } from '@prisjakt/ui/text/variants';

import { BaseProps } from '../types';

type Props = Pick<BaseProps, 'category' | 'rank' | 'onRankInCategoryClick'>;

export const RankInCategory = (props: Props) => {
  const { rank, category, onRankInCategoryClick } = props;

  const { renderMode, t } = useAppContext();

  return rank && category ? (
    <div>
      {t('product', 'rank.in-category', {
        categoryRank: t('product', 'rank.position', {
          rank,
        }),
        categoryLink: (
          <BodySmallText
            key="categoryLink"
            container={Clickable}
            containerProps={{
              to: category.pathName,
              isExternal: renderMode === 'native',
              onClick: () => onRankInCategoryClick?.(),
            }}
          >
            {category.name}
          </BodySmallText>
        ),
      })}
    </div>
  ) : null;
};
